<template>
    <div class="page-table-layout" data-testid="financialclose-chartofaccountnew__view">
        <v-card class="all-width flex-card shadow-off" :loading="loading" :disabled="loading" loader-height="2" data-testid="financialclose-chartofaccountnew__card">
            <v-card-text class="page-table-layout__body">
                <div class="d-flex align-center justify-space-between pt-4">
                    <div class="d-flex align-end">
                        <div class="d-flex flex-column">
                            <div
                            class="financialclose-chartofaccountnew__title-prefix"
                            data-testid="financialclose-chartofaccountnew__title-prefix"
                            >
                            Setup
                            </div>
                            <div class="d-flex align-center ma-0">
                            <h3 class="font-weight-medium ma-0">Chart of Account</h3>
                            </div>
                        </div>

                        <v-tooltip bottom content-class="tooltip-bottom" >
                        <template v-slot:activator="{ on, attrs }"> 
                            <v-btn 
                                v-bind="attrs"
                                v-on="on"
                                class="shadow-off ml-1" icon @click="refreshData()" data-testid="financialclose-chartofaccountnew__refresh-btn"><v-icon
                                size="24">mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Refresh</span>
                      </v-tooltip>

                       <activity-log 
                        :resource-id="clientID"
                        data-testid="financialclose-chartofaccountnew__activity-log-btn"
                        :row-description="'Chart of Account'" 
                        :type="$options.ACTIVITY_LOG_TYPES.MASTER_CHART_OF_ACCOUNT"
                        />
                      
                    </div>
                    <div class="d-flex align-center ma-0">

                        <bulkChartOfAccountUpload @reload="refreshData()" v-if="$nova.hasRight(right, 'add')" data-testid="financialclose-chartofaccountnew__bulk-upload" />
                        <v-btn  color="primary" class="white--text" @click="resetAddEditForm()" v-if="$nova.hasRight(right, 'add')" data-testid="financialclose-chartofaccountnew__new-account-btn">
                            <v-icon class="pr-2">mdi-plus</v-icon>
                            <span class="text-capitalize"><span>New Account</span></span>
                        </v-btn>
                    </div>
                </div>
                <div class="d-flex align-center justify-space-between my-3 ">
                   <!-- /* TODO: Temporarily set to display: none; for current requirements. Will be updated in future versions. */ -->
                    <div class="d-none">
                    <lb-string placeholder="Search" label="" v-model="search" width="30vh" appendiconinner="mdi-magnify"
                        hidedetails :isClearable="false" radius="8px" data-testid="fbc-chartofaccountnew__search-string" />
                        <v-tooltip bottom content-class="tooltip-bottom">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ma-2" text icon color="lighten-2" v-bind="attrs" v-on="on" data-testid="financialclose-chartofaccountnew__search-info-btn">
                            <v-icon>mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <span><span>Search for the account name </span></span>
                    </v-tooltip>
                    </div>
                    <v-spacer></v-spacer>
                    
                    <!-- Clear Filter Button -->
                    <v-btn
                        v-if="hasActiveTableFilter"
                        text
                        class="mr-2 data-table-action__clear-filter-btn"
                        @click="clearTableFilter()"
                        data-testid="financialclose-chartofaccountnew__toolbar-clear-filter-btn"
                    >
                        <span>Clear Filter</span>
                    </v-btn>
                    <!-- CustomizeColumnMenu component - Apply only -->
                    <CustomizeColumnMenu
                      v-model="customizeMenuOpen"
                      :headers="headers"
                      color="caccounting"
                      :show-save-button="false"
                      :show-apply-button="true"
                      data-testid-prefix="financialclose-chartofaccountnew"
                      @apply="handleApplyColumns"
                    />
                </div>

                <div class="flex-fill-table">
                <lb-datatableaction ref="dataTableAction" :headers="headers" :tabledata="formatedDataCopy" :itemsperpage="itemsPerPage"
                    :displayedRowCount="paginatedFilteredItems.length"
                    :filter-options-data="columnFilterSourceData"
                    :searchterm="search" :bulkActions="false" @filter-item="filterPart" @filter-active-change="onFilterActiveChange" @clear-item="clearPart" data-testid="financialclose-chartofaccountnew__datatable">

                    <template v-slot:tbody>
                        <tr v-for="item in paginatedFilteredItems" :key="item._id" class="cursor-pointer  "
                            :class="{ 'low-opacity': item.status === false }" data-testid="financialclose-chartofaccountnew__datatable-row">
                            <template v-for="header in headers">
                                <td v-if="header.visible && header.value !== 'action'" :key="header.value" :class="{'description-header': header.value === 'name'}"
                                    class="px-4 single-line" @click="viewchartAcc(item)">
                                    <div v-if="header.value === 'tasklist'" class="d-flex align-center">
                                        <OverflowList
                                            :items="item.taskRefs || []"
                                            empty-text=""
                                            position="bottom"
                                            fixed
                                            content-class="chart-of-account-fixed-tooltip"
                                            data-testid="financialclose-chartofaccountnew__datatable-tasklist-more"
                                        >
                                            <template #primary="{ item: taskRef }">
                                                <span
                                                    class="d-inline-flex width-fit pa-2 caccounting-background radius-mini caccounting--text"
                                                    data-testid="financialclose-chartofaccountnew__datatable-tasklist-ref"
                                                >{{ taskRef }}</span>
                                            </template>
                                        </OverflowList>
                                    </div>
                                    <div class="d-flex align-center" v-else-if="header.value === 'location'">
                                        <OverflowList
                                            :items="item.location || []"
                                            empty-text=""
                                            position="bottom"
                                            fixed
                                            content-class="chart-of-account-fixed-tooltip"
                                            data-testid="financialclose-chartofaccountnew__datatable-location-more"
                                        >
                                            <template #primary="{ item: locationName }">
                                                <span
                                                    class="d-inline-flex width-fit pa-2 caccounting-background radius-mini caccounting--text"
                                                    data-testid="financialclose-chartofaccountnew__datatable-location"
                                                >{{ locationName }}</span>
                                            </template>
                                        </OverflowList>
                                    </div>
                                    <span v-else-if="header.value === 'created_at' || header.value === 'updated_at'"> {{
                                        getItemData(item, header.value)?.split('T')?.[0] }} </span>
                                    <span v-else> {{ getItemData(item, header.value) }}</span>
                                </td>
                                <td v-else-if="header.value === 'action'" :key="header.value"
                                    class=" px-3 single-line border-right border-left action-data" data-testid="financialclose-chartofaccountnew__datatable-action-cell">
                                    <v-tooltip bottom content-class="tooltip-bottom"  >
                                        <template v-slot:activator="{ on, attrs }"> 
                                            <v-btn v-bind="attrs" v-on="on" icon  :disabled="!item.status" @click="addEditForm(item)" data-testid="financialclose-chartofaccount__edit-btn"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                                        </template>
                                        <span>Edit</span>
                                      </v-tooltip>
                                      
                                      <v-tooltip bottom content-class="tooltip-bottom" v-if="item.status">
                                        <template v-slot:activator="{ on, attrs }"> 
                                        <v-btn  v-bind="attrs" v-on="on" icon @click="enableDisableAccess(item._id, 'disable')" data-testid="financialclose-chartofaccountnew__datatable-action-cell-enable-btn"><v-icon
                                            color="success">mdi-check-circle</v-icon></v-btn>
                                        </template>
                                        <span>Enable</span>
                                      </v-tooltip>

                                      <v-tooltip bottom content-class="tooltip-bottom"  v-else>
                                        <template v-slot:activator="{ on, attrs }"> 
                                            <v-btn v-bind="attrs" v-on="on" icon
                                                @click="enableDisableAccess(item._id, 'enable')" data-testid="financialclose-chartofaccountnew__datatable-action-cell-disable-btn"><v-icon
                                                    color="error">mdi-close-circle</v-icon></v-btn>
                                        </template>
                                        <span>Disable</span>
                                      </v-tooltip>
                                      <activity-log 
                                        :resource-id="item._id" 
                                        data-testid="financialclose-project-users__activitylog"
                                        :row-description="item.name" 
                                        />
                                </td>
                                
                            </template>
                            

                        </tr>
                    </template>
                </lb-datatableaction>
                </div>

                
            </v-card-text>
        </v-card>
        
        <lb-drawer v-model="addeditdialog" :heading="addeditdata._id ? 'Update' : 'Add New'" width="600"
        :loading="addeditloading" data-testid="financialclose-chartofaccountnew__add-edit-drawer">
        <template v-slot:body>
                <div class="chart-of-account-form" data-testid="financialclose-chartofaccountnew__add-edit-form">
                    <h5 class="chart-of-account-form__section-title chart-of-account-form__section-title--required" data-testid="financialclose-chartofaccountnew__add-edit-details-title">Details</h5>

                    <div class="chart-of-account-form__row">
                        <div class="chart-of-account-form__row-item">
                            <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">Account no.</p>
                            <lb-string v-model="addeditdata.glcode" label="" placeholder="Enter Account number"
                                :error="addeditdataerror.glcode" :hidedetails="true" :isRequired="true" :isClearable="false"
                                data-testid="financialclose-chartofaccountnew__add-edit-glcode" />
                            <p
                                v-if="addeditdataerror.glcode"
                                class="chart-of-account-form__field-error"
                                role="alert"
                                data-testid="financialclose-chartofaccountnew__add-edit-glcode-error"
                            >
                                {{ addeditdataerror.glcode }}
                            </p>
                        </div>
                        <div class="chart-of-account-form__row-item">
                            <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">Type</p>
                            <lb-dropdown v-model="addeditdata.type" label="" :error="addeditdataerror.type"
                                :hidedetails="true" :items="possibletypes" placeholder="Enter Type" appendiconinner="mdi-chevron-down"
                                :clearable="false" data-testid="financialclose-chartofaccountnew__add-edit-type" />
                            <p
                                v-if="addeditdataerror.type"
                                class="chart-of-account-form__field-error"
                                role="alert"
                                data-testid="financialclose-chartofaccountnew__add-edit-type-error"
                            >
                                {{ addeditdataerror.type }}
                            </p>
                        </div>
                    </div>

                    <div class="chart-of-account-form__field">
                        <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">Account Name</p>
                        <lb-textBox v-model="addeditdata.name" label="" requriedrows="3"
                            placeholder="Enter Account name" :isRequired="true" :error="addeditdataerror.name"
                            :hidedetails="true" data-testid="financialclose-chartofaccountnew__add-edit-name" />
                        <p
                            v-if="addeditdataerror.name"
                            class="chart-of-account-form__field-error"
                            role="alert"
                            data-testid="financialclose-chartofaccountnew__add-edit-name-error"
                        >
                            {{ addeditdataerror.name }}
                        </p>
                    </div>

                    <div class="chart-of-account-form__row">
                        <div class="chart-of-account-form__row-item">
                            <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">Category</p>
                            <lb-string v-model="addeditdata.category" label="" :error="addeditdataerror.category"
                                :hidedetails="true" placeholder="Enter Category" :isRequired="true" :isClearable="false"
                                data-testid="financialclose-chartofaccountnew__add-edit-category" />
                            <p
                                v-if="addeditdataerror.category"
                                class="chart-of-account-form__field-error"
                                role="alert"
                                data-testid="financialclose-chartofaccountnew__add-edit-category-error"
                            >
                                {{ addeditdataerror.category }}
                            </p>
                        </div>
                        <div class="chart-of-account-form__row-item">
                            <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">Sub Category</p>
                            <lb-string v-model="addeditdata.subcategory" label="" :error="addeditdataerror.subcategory"
                                :hidedetails="true" placeholder="Enter Sub Category" :isRequired="true" :isClearable="false"
                                data-testid="financialclose-chartofaccountnew__add-edit-subcategory" />
                            <p
                                v-if="addeditdataerror.subcategory"
                                class="chart-of-account-form__field-error"
                                role="alert"
                                data-testid="financialclose-chartofaccountnew__add-edit-subcategory-error"
                            >
                                {{ addeditdataerror.subcategory }}
                            </p>
                        </div>
                    </div>

                    <div class="chart-of-account-form__field chart-of-account-form__location">
                        <p class="chart-of-account-form__label chart-of-account-form__label--required ma-0">{{$store.state.LocationHeader|| 'Location'}}</p>
                        <ChipMultiSelect
                            v-model="addeditdata.locationId"
                            variant="add-task"
                            :items="locationItem"
                            item-text="name"
                            item-value="name"
                            placeholder="Select Location"
                            :error="addeditdataerror.locationId"
                            data-testid="financialclose-chartofaccountnew__add-edit-location"
                            data-testid-prefix="chart-of-account__location"
                        />
                    </div>

                    <div class="chart-of-account-form__field chart-of-account-form__link-tasks">
                        <p class="chart-of-account-form__label ma-0">Link Tasks</p>
                        <v-menu
                            v-model="taskMenuOpen"
                            :close-on-content-click="false"
                            offset-y
                            :nudge-bottom="4"
                            content-class="chart-of-account-form__link-tasks-menu"
                            transition="slide-y-transition"
                            data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-menu"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <button
                                    type="button"
                                    class="chart-of-account-form__link-tasks-trigger"
                                    v-bind="attrs"
                                    v-on="on"
                                    data-testid="financialclose-chartofaccount__add-tasks-btn"
                                >
                                    <span class="chart-of-account-form__link-tasks-placeholder">{{ tasklistlocation.length ? `${tasklistlocation.length} selected` : emptyMessages.LINK_TASKS_PLACEHOLDER }}</span>
                                    <v-icon size="16" color="grey">mdi-chevron-down</v-icon>
                                </button>
                            </template>

                            <v-card class="chart-of-account-form__link-tasks-card pa-0 ma-0" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-card">
                                <div class="chart-of-account-form__link-tasks-header" data-testid="financialclose-chartofaccount__select-task">
                                    <p class="ma-0">Select Task</p>
                                    <v-btn icon small @click="closeTaskMenu" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-close-btn">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </div>
                                <div class="chart-of-account-form__link-tasks-search">
                                    <lb-string
                                        placeholder="Search"
                                        label=""
                                        v-model="searchTask"
                                        :hidedetails="true"
                                        appendiconinner="mdi-magnify"
                                        data-testid="financialclose-chartofaccount__search"
                                    />
                                </div>
                                <div class="chart-of-account-form__link-tasks-body">
                                    <v-simple-table
                                        v-if="filtertasklist.length"
                                        dense
                                        class="chart-of-account-form__link-tasks-table simple-table"
                                        data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-table"
                                    >
                                        <thead class="tableHeaderBg">
                                            <tr>
                                                <th class="tableHeaderBg pa-2 text-center" style="width: 50px;">
                                                    <v-checkbox
                                                        v-model="selectAll"
                                                        @change="toggleSelectAll"
                                                        :indeterminate="selectItem.length > 0 && selectItem.length < filtertasklist.length"
                                                        hide-details
                                                        class="ma-0 pa-0 d-flex justify-center task-select-all-checkbox"
                                                        data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-select-all-checkbox"
                                                    ></v-checkbox>
                                                </th>
                                                <th class="tableHeaderBg pa-2" style="width: 100px;">Reference</th>
                                                <th class="tableHeaderBg pa-2 chart-of-account-form__link-tasks-col-description">Description</th>
                                                <th class="tableHeaderBg pa-2" style="width: 120px;">Category</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in filtertasklist" :key="item._id || index" class="cursor-pointer">
                                                <td class="text-center" style="width: 50px;">
                                                    <v-checkbox
                                                        :input-value="isTaskSelected(item)"
                                                        @change="toggleTaskSelection(item, $event)"
                                                        hide-details
                                                        color="caccounting"
                                                        class="ma-0 pa-0 d-flex justify-center"
                                                        data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-select-row-checkbox"
                                                    ></v-checkbox>
                                                </td>
                                                <td style="width: 100px;">{{ item.ref }}</td>
                                                <td class="chart-of-account-form__link-tasks-col-description">
                                                    <v-tooltip
                                                        bottom
                                                        :z-index="tooltipZIndex"
                                                        content-class="tooltip-bottom chart-of-account-form__tooltip"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span
                                                                class="chart-of-account-form__truncate"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            >{{ item.description }}</span>
                                                        </template>
                                                        <span>{{ item.description }}</span>
                                                    </v-tooltip>
                                                </td>
                                                <td style="width: 120px;">
                                                    <v-tooltip
                                                        bottom
                                                        :z-index="tooltipZIndex"
                                                        content-class="tooltip-bottom chart-of-account-form__tooltip"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on">{{ item.category }}</span>
                                                        </template>
                                                        <span>{{ item.category }}</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                    <div
                                        v-else
                                        class="chart-of-account-form__link-tasks-empty"
                                        data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-empty"
                                    >
                                        {{ emptyMessages.LINK_TASKS_NO_DATA }}
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <div class="chart-of-account-form__link-tasks-actions">
                                    <v-btn class="primary" @click="addRows" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-add-btn"><span>Add</span></v-btn>
                                </div>
                            </v-card>
                        </v-menu>
                            <v-simple-table class="border-on simple-table mt-2" v-if="tasklistlocation.length > 0" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table">
                                <thead class="tableHeaderBg">
                                    <th class="tableHeaderBg pa- text-left" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-header-reference">Reference</th>
                                    <th class="tableHeaderBg pa-2 text-left chart-of-account-form__link-tasks-col-description" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-header-description">Description</th>
                                    <th class="tableHeaderBg pa-2 text-left" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-header-category">Category</th>
                                    <th class="tableHeaderBg pa-2 text-left" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-header-actions">Actions</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in tasklistlocation" :key="index" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row">
                                        <td data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row-reference">{{ item.ref }}</td>
                                        <td class="chart-of-account-form__link-tasks-col-description" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row-description">
                                            <v-tooltip
                                                bottom
                                                :z-index="tooltipZIndex"
                                                content-class="tooltip-bottom chart-of-account-form__tooltip"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span class="chart-of-account-form__truncate" v-bind="attrs" v-on="on">{{ item.description }}</span>
                                                </template>
                                                <span>{{ item.description }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row-category">{{ item.category }}</td>
                                        <td data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row-actions">
                                            <v-btn icon @click="removetasklist(item)" data-testid="financialclose-chartofaccountnew__add-edit-linked-tasks-added-table-row-delete-btn">
                                                <v-icon color="error">mdi-delete</v-icon></v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="chart-of-account-form__save-btn text-none white--text" @click="addEditItem()" data-testid="financialclose-chartofaccountnew__add-edit-save-btn">
                    <span v-if="addeditdata._id" data-testid="financialclose-chartofaccountnew__add-edit-save-btn-update">Update</span>
                    <span v-else data-testid="financialclose-chartofaccountnew__add-edit-save-btn-add">Add</span>
                </v-btn>
            </template>
        </lb-drawer>

        <lb-drawer v-model="viewchartaccdialog" heading="Account Details" width="800" data-testid="financialclose-chartofaccountnew__view-drawer">
            <template v-slot:body>
                <div>
                    <div class="d-flex body-1 align-center justify-start mb-3">
                        <span
                            class="caccounting-background caccounting--text px-2 py-1 radius-small font-weight-bold mr-3">{{
                                viewchartaccdata.glcode }}</span>
                        <div class="font-weight-bold black--text">{{ viewchartaccdata.name || "" }}</div>
                    </div>
                    <div class="">
                        <v-row>
                            <v-col cols="3"> Type</v-col>
                            <v-col cols="9"> <span class="gray-background pa-1 radius-mini black--text">{{
                                viewchartaccdata.type || "" }} </span> </v-col>
                            <v-col cols="3"> Location</v-col>
                            <v-col cols="9" class="d-flex">
                                <div class="mr-2" v-for="(item, index) in viewchartaccdata.location " :key="index">
                                    <span class="caccounting-background caccounting--text pa-1 radius-mini">{{ item }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="3"> Category</v-col>
                            <v-col cols="9"> <span class="gray-background pa-1 radius-mini black--text">{{
                                viewchartaccdata.category || "" }} </span></v-col>
                            <v-col cols="3"> Sub Category</v-col>
                            <v-col cols="9"> <span class="gray-background pa-1 radius-mini black--text">{{
                                viewchartaccdata.subcategory || "" }} </span></v-col>
                        </v-row>
                    </div>
                    <div class="">
                        <v-row>
                            <v-col cols="12" class="mt-0">
                                <div class="font-weight-bold  py-1">
                                    <div class="d-flex align-center">
                                        <div class="font-size-md black--text pt-2">Linked Task</div>
                                        <v-spacer></v-spacer>
                                        <div v-if="(viewchartaccdata.checklist_id_detail || []).length > 0">
                                            <span class="font-wight-bold">Total Count:</span>
                                            {{ viewchartaccdata.checklist_id_detail.length }}
                                        </div>
                                    </div>
                                </div>
                                <v-simple-table dense class=" mb-2 border-on radius-small simple-table"
                                    v-if="(viewchartaccdata.checklist_id_detail || []).length > 0" data-testid="financialclose-chartofaccountnew__view-linked-tasks-table">
                                    <template v-slot:default>
                                        <thead class="tableHeaderBg" >
                                            <th class="text-left font-size-md black--text tableHeaderBg py-2 px-3">Ref
                                            </th>
                                            <th class="text-left font-size-md black--text tableHeaderBg py-2 px-3">
                                                Description</th>
                                            <th class="text-left font-size-md black--text tableHeaderBg py-2 px-3">
                                                Category</th>
                                        </thead>
                                        <v-slide-y-transition class="" group tag="tbody"
                                            style="overflow:hidden !important;">
                                            <tr v-for="(v, k) in viewchartaccdata.checklist_id_detail" :key="k"
                                                class="" data-testid="financialclose-chartofaccountnew__view-linked-tasks-table-row">
                                                <td class="pa-3" data-testid="financialclose-chartofaccountnew__view-linked-tasks-table-row-ref"> <span
                                                        class="caccounting-background caccounting--text pa-2 radius-mini">{{
                                                        v.ref }}</span>
                                                </td>
                                                <td class="" data-testid="financialclose-chartofaccountnew__view-linked-tasks-table-row-description">{{ v.description }}</td>
                                                <td class="" data-testid="financialclose-chartofaccountnew__view-linked-tasks-table-row-category">{{ v.category }}</td>
                                            </tr>
                                        </v-slide-y-transition>
                                    </template>
                                </v-simple-table>
                                <div v-else class="grey--text px-4 mb-2">No Data</div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </template>
        </lb-drawer>

        <!-- Pagination -->
        <Pagination :list="filteredItemsfromsearch" :itemsperpage="itemsPerPage" @paginated-data="setPaginatedData" data-testid="financialclose-chartofaccountnew__pagination" />

    </div>
</template>

<script>
import { mapActions } from "vuex";
import Pagination from "../../../components/Pagination/Pagination.vue";
import bulkChartOfAccountUpload from "./components/BulkUploadChartOfAccount/BulkUploadChartOfAccount.vue";
import CustomizeColumnMenu from "../../../components/CustomizeColumnMenu/CustomizeColumnMenu.vue";
import ActivityLog from "../../../components/ActivityLog/ActivityLog.vue";
import { ChipMultiSelect } from "../../../components";
import { OverflowList } from "@/modules/financialclose/components";
import { ACTIVITY_LOG_TYPES } from "../../../utils/constants";
import {
    TASK_LINKED_FILTER_FIELD,
    normalizeChartOfAccountFilterCriteria,
    validateChartOfAccountData as validateChartOfAccountForm,
    COA_EMPTY_MESSAGES,
    COA_TOOLTIP_Z_INDEX,
    chartOfAccountLocationEntries,
    locationEntriesToNames,
    locationEntriesToDocs,
    uniqueTaskEntries,
    uniqueTaskIds,
    linkedTaskRefs,
} from "./ChartOfAccountUtils";
import "./ChartOfAccount.scss";
export default {
    name: "financialclose_master_chartofaccount",
    ACTIVITY_LOG_TYPES,
    // props: ['props'],
    data: function () {
        return {
            clientID:this.$store.state.client,
            right: "financialclose_master_chartofaccount",
            // generateddescription: "",
            tableheader: [
                { text: "GL Code", value: "glcode" },
                { text: "Name", value: "name" },
                { text: "Type", value: "type" },
                { text: "Category", value: "category" },
                { text: "Sub Category", value: "subcategory" },
                { text: "Tasklist", value: "checklist_id" },
                { text: "Action", value: "action", align: "center", sortable: false },
            ],
            possibletypes: [
                "Asset",
                "Equity",
                "Liability",
                "Income",
                "Expense",
                "Others",
            ],
            addeditdata: {},
            addeditdataerror: {},
            addeditdialog: false,
            locationUserList: [],
            customassertions: false,
            checklist: [],
            addeditloading: false,
            loading: false,
            hasActiveTableFilter: false,
            listdata: [],
            headers: [

                {
                    value: "glcode",
                    text: "Account No.",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "name",
                    text: "Account Name",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "type",
                    text: "Type",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "category",
                    text: "Category",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "subcategory",
                    text: "Sub Category",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "tasklist",
                    text: "Task Linked",
                    visible: true,
                    filterable: true,
                    sortable: false,
                    noTruncate: true,
                },
                {
                    value: "location",
                    text:this.$store.state.LocationHeader|| 'Location',
                    visible: true,
                    filterable: true,
                    sortable: false,
                    noTruncate: true,
                },
                {
                    value: "created_at",
                    text: "Created On",
                    visible: true,
                    filterable: true,
                    sortable: true,
                },
                {
                    value: "updated_at",
                    text: "Updated On",
                    visible: true,
                   filterable: true,
                    sortable: true,
                },
                {
                    value: "action",
                    text: "Action",
                    sticky: true,
                    visible: true,
                    filterable: false,
                    sortable: false,
                },
            ],
            formatedData: [],
            formatedDataCopy: [],
            selectchecklistdialog: false,
            selectchecklist: [],
            searchcustom: '',
            checklistIds: [],
            viewchartaccdialog: false,
            viewchartaccdata: {},
            filteredItems: [],
            locationItem: [],
            searchTask: "",
            emptyMessages: COA_EMPTY_MESSAGES,
            tooltipZIndex: COA_TOOLTIP_Z_INDEX,
            tasklistlocation: [],
            itemsPerPage: 13,
            search: '',
            selectedFilterItems: [],
            selectItem: [],
            searchcolumn: '',
            selectlocation_id: '',
            selectchecklist_id: '',
            selectedRows: [],
            selectAll: false,
            paginatedFilteredItems:[],
            customizeMenuOpen: false,
            activeFilter: null,
            taskMenuOpen: false,
        };
    },
    created() {
        this.init();
    },
    activated() {
        this.init();
    },
    components: {
        bulkChartOfAccountUpload,
        Pagination,
        CustomizeColumnMenu,
        ChipMultiSelect,
        OverflowList,
        'activity-log': ActivityLog,
    },
    computed: {
        filtertasklist() {
            const searchTerm = this.searchTask.toLowerCase();
            return this.checklist.filter(item => {
                // Search by ref, description, and category
                const refMatch = (item.ref || '').toLowerCase().includes(searchTerm);
                const descriptionMatch = (item.description || '').toLowerCase().includes(searchTerm);
                const categoryMatch = (item.category || '').toLowerCase().includes(searchTerm);
                return refMatch || descriptionMatch || categoryMatch;
            });
        },
        filteredItemsfromsearch() {
            let filteredData = this.formatedData.filter(item =>
                item.name.toLowerCase().includes(this.search?.trim()?.toLowerCase())
            );
            return filteredData;
        },
        filteredHeaders() {
            const searchTerm = this.searchcolumn.toLowerCase();
            return this.headers.filter(header =>
                header.text.toLowerCase()?.includes(searchTerm)
            );
        },
        columnFilterSourceData() {
            return (this.formatedDataCopy || []).map((row) => ({
                ...row,
                tasklist: Array.isArray(row[TASK_LINKED_FILTER_FIELD])
                    ? row[TASK_LINKED_FILTER_FIELD]
                    : row.tasklist,
            }));
        },
    },
    methods: {
        ...mapActions('chartOfAccount', ['saveChartOfAccount']),
        /**
         * Handler for filter-active-change event from DataTableAction
         */
        onFilterActiveChange(isActive) {
            this.hasActiveTableFilter = isActive;
        },
        /**
         * Clear table filters via DataTableAction ref
         */
        clearTableFilter() {
            if (this.$refs.dataTableAction) {
                this.$refs.dataTableAction.clearFilter();
            }
        },
        /**
         * Validate Chart of Account data fields before add/edit API call
         * Checks for null, undefined, empty, and length constraints
         * Returns an object with error messages for each invalid field
         */
        validateChartOfAccountData(data) {
            return validateChartOfAccountForm(
                data,
                this.$store.state.LocationHeader || 'Location',
                this.locationItem
            );
        },
        resetAddEditForm() {
            this.addeditdialog = true;
            this.addeditdata = { locationId: [] };
            this.addeditdataerror = {};
            this.locationUserList = [];
            this.customassertions = false;
            this.tasklistlocation = [];
            this.checklistIds = [];
            this.selectedRows = [];
        },
        setPaginatedData(paginationInfo) {
            if (paginationInfo && typeof paginationInfo === 'object' && 'data' in paginationInfo) {
                this.paginatedFilteredItems = paginationInfo.data || [];
                this.page = paginationInfo.page || 1;
            } else {
                this.paginatedFilteredItems = paginationInfo || [];
            }
        },
        toggleSelectAll() {
            this.selectedRows = this.selectAll
                ? uniqueTaskEntries([...this.selectedRows, ...this.filtertasklist])
                : [];
        },
        addRows() {
            this.tasklistlocation = uniqueTaskEntries(this.selectedRows);
            this.addeditdata.checklist_id_detail = this.tasklistlocation;
            this.checklistIds = uniqueTaskIds(this.tasklistlocation);
            this.taskMenuOpen = false;
        },
        formateData() {
            let ObjectTemp = {};
            let ArrayTemp = [];
            this.listdata.forEach((item, index) => {
                const linkedTasks = uniqueTaskEntries(item.checklist_id);
                const taskRefs = linkedTaskRefs(
                    linkedTasks,
                    item.checklist_id_detail,
                    (id) => this.getTaskName(id)
                );
                ObjectTemp = {
                    __key: index,
                    __formatedkey: index,
                    _id: item._id,
                    indexno: index + 1,
                    glcode: item.glcode,
                    name: item.name,
                    type: item.type,
                    category: item.category,
                    subcategory: item.subcategory,
                    tasklist: linkedTasks,
                    taskRefs,
                    [TASK_LINKED_FILTER_FIELD]: taskRefs,
                    checklist_id_detail: uniqueTaskEntries(item.checklist_id_detail),
                    location: locationEntriesToNames(
                        chartOfAccountLocationEntries(item),
                        this.locationItem
                    ),
                    created_at: item.created_at?.split("T")[0],
                    updated_at: item.updated_at?.split("T")[0],
                    status: item.status,
                    __click: this.viewchartAcc,
                };
                ArrayTemp.push(ObjectTemp);
            });
            this.formatedData = ArrayTemp;
            this.formatedDataCopy = ArrayTemp;
        },
        init() {
            this.refreshData();
        },
        refreshData() {
            this.charts = [];
            this.chartdata = {};
            this.listdata = [];
            this.getData();
        },
        getData() {
            this.loading = true;
            return this.axios
                .post("/v2/financialclose/masters/chartofaccount/formData")
                .then((dt) => {
                    if (dt.data.status === "success") {
                        let formdt = dt.data.data[0] || {};
                        this.checklist = formdt.checklist || [];
                        return this.axios.post(
                            "/v2/financialclose/masters/chartofaccount/get"
                        );
                    } else throw new Error("Error reading form data");
                })
                .then((dt) => {
                    this.listdata = [];
                    if (dt.data.status === "success") {
                        this.listdata = dt.data.data;
                        this.formateData();
                    } else throw new Error(dt.data.message);
                })
                .then(() => {
                    this.axios
                        .post("/v2/financialclose/location/get")
                        .then((ele) => {
                            this.locationItem = ele.data.data;
                            this.formateData();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        addTableHeader(item) {
            this.headers.find((x) => x === item ? x.visible = !x.visible : "")
        },
        /**
         * Handle Apply button click from CustomizeColumnMenu
         * Updates column visibility locally (session only)
         * @param {Array} headers - Updated headers array
         */
        handleApplyColumns(headers) {
            this.headers = headers;
            this.customizeMenuOpen = false;
        },
        addEditForm(dt = {}) {
            // Include locationId on the object before assignment so Vue 2 observes it.
            // Table rows only have `location` names; assigning locationId afterward is not reactive.
            const locationId = locationEntriesToNames(
                chartOfAccountLocationEntries(dt),
                this.locationItem
            );
            this.addeditdata = { ...dt, locationId };
            // Initialize checklistIds from existing tasklist array
            this.checklistIds = uniqueTaskIds(dt.tasklist);
            this.addeditdataerror = {};
            this.tasklistlocation = uniqueTaskEntries(this.addeditdata.checklist_id_detail);
            this.selectedRows = [...this.tasklistlocation];
            this.addeditdialog = true;
        },
        addEditItem() {
            // Validate before API call
            const errors = this.validateChartOfAccountData(this.addeditdata);
            this.addeditdataerror = errors;
            if (Object.keys(errors).length > 0) {
                this.$store.commit("sbError", "Please fill all required fields correctly.");
                return;
            }
            const locationDocs = locationEntriesToDocs(this.addeditdata.locationId, this.locationItem);
            const linkedTaskDetails = uniqueTaskEntries(this.addeditdata.checklist_id_detail);
            const linkedTaskIds = uniqueTaskIds(this.checklistIds.length ? this.checklistIds : linkedTaskDetails);
            this.addeditdata.checklist_id_detail = linkedTaskDetails;
            this.addeditdata.checklist_id = linkedTaskIds;
            this.addeditloading = true;
            const account = {
                glcode: this.addeditdata.glcode,
                name: this.addeditdata.name,
                type: this.addeditdata.type,
                category: this.addeditdata.category,
                subcategory: this.addeditdata.subcategory,
                checklist_id: linkedTaskIds,
                checklist_id_detail: linkedTaskDetails,
                location: locationDocs.map((loc) => ({
                    name: loc.name,
                    _id: loc._id,
                })),
                locationId: locationDocs.map((loc) => loc._id),
            };
            this.saveChartOfAccount({ id: this.addeditdata._id || '', account })
                .then((result) => {
                    if (result && result.ok) {
                        this.addeditdialog = false;
                        this.refreshData();
                        return;
                    }
                    if (result && result.fieldErrors) this.addeditdataerror = result.fieldErrors;
                })
                .finally(() => {
                    this.addeditloading = false;
                });
        },
        enableDisableAccess(id, action) {
            this.loading = true;
            let url = "/v2/financialclose/masters/chartofaccount/disable/";
            if (action === "enable") {
                url = "/v2/financialclose/masters/chartofaccount/enable/";
            }
            this.axios
                .post(url + id, {})
                .then((dt) => {
                    if (dt.data.status === "success") {
                        if (action === "enable") {
                            this.$store.commit("sbSuccess", "Item enabled");
                            // this.listdata[k].status = true;
                        } else {
                            this.$store.commit("sbSuccess", "Item disabled");
                            // this.listdata[k].status = false;
                        }
                        this.refreshData();
                    } else throw new Error(dt.data.message || "Error performing action");
                })
                .catch((err) => {
                    this.$store.commit("sbError", err.message || err || "Unknown error!");
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        viewchartAcc(item) {
            this.viewchartaccdata = { ...item };
            this.viewchartaccdialog = true;
        },
        getItemData(item, key) {
            return item[key];
        },
        getTaskName(taskId) {
            const id = taskId && typeof taskId === 'object'
                ? (taskId._id || taskId.checklist_id)
                : taskId;
            if (!id) {
                return taskId && typeof taskId === 'object' ? taskId : {};
            }
            const task = (this.checklist || []).find((entry) => String(entry._id) === String(id));
            if (task) return task;
            return taskId && typeof taskId === 'object' ? taskId : {};
        },
        removetasklist(item) {
            let indexItem = this.tasklistlocation.indexOf(item);
            this.tasklistlocation.splice(indexItem, 1);
            this.addeditdata.checklist_id_detail = (this.addeditdata.checklist_id_detail || []).filter((x) => x._id !== item._id);
            // Update checklistIds array when removing tasks
            this.checklistIds = this.checklistIds.filter((id) => id !== item._id);
            // Update selectedRows to keep checkbox state in sync
            this.selectedRows = this.selectedRows.filter((row) => row._id !== item._id);
        },
        /**
         * Check if a task is already selected (exists in selectedRows)
         * Used to show checkbox as checked for pre-selected tasks
         * @param {Object} task - Task item to check
         * @returns {Boolean} - True if task is selected
         */
        isTaskSelected(task) {
            return this.selectedRows.some(row => row._id === task._id);
        },
        /**
         * Toggle task selection in the search table
         * Handles checkbox state by adding/removing from selectedRows by _id
         * @param {Object} task - Task item to toggle
         * @param {Boolean} isChecked - New checkbox state
         */
        toggleTaskSelection(task, isChecked) {
            if (isChecked) {
                // Add task if not already in selectedRows
                if (!this.selectedRows.some(row => row._id === task._id)) {
                    this.selectedRows.push(task);
                }
            } else {
                // Remove task from selectedRows
                this.selectedRows = this.selectedRows.filter(row => row._id !== task._id);
            }
        },
        /**
         * Close the task selection menu
         */
        closeTaskMenu() {
            this.taskMenuOpen = false;
            this.searchTask = '';
        },
    filterPart(item){
        const criteria = normalizeChartOfAccountFilterCriteria(item);
        this.activeFilter = JSON.parse(JSON.stringify(criteria));
        this.formatedData = this.$nova.filterByDynamicCriteria(this.formatedDataCopy, criteria);  
      },
    clearPart(){
        this.activeFilter = null;
        this.formatedData = this.formatedDataCopy;
      }
    },
    watch: {
      taskMenuOpen(isOpen) {
        if (!isOpen) this.searchTask = '';
      },
      // Reapply filter when data is refreshed
      formatedDataCopy: {
        handler(newList) {
          if (this.activeFilter) {
            this.formatedData = this.$nova.filterByDynamicCriteria(newList, this.activeFilter);
          } else {
            this.formatedData = newList;
          }
        },
        deep: true
      }
    },
};
</script>